/**
 * Checks if the given value looks like an image URL or path (by file extension).
 * Handles URLs with query strings (e.g. "https://example.com/photo.jpg?token=123").
 * @param {*} value - String URL, path, or filename
 * @returns {boolean}
 */
export function isImageUrl(value) {
	if (typeof value !== 'string' || !value.trim()) return false;
	const str = value.trim().toLowerCase();
	return /\.(jpg|jpeg|png|gif|webp|svg)(\?|$)/i.test(str);
}

/**
 * Parses file/image value into array of URL strings.
 * Handles: single URL string, JSON array string "[\"url1\",\"url2\"]", {files: [{url}]}, Array.
 * @param {*} value - Raw value from backend
 * @returns {string[]}
 */
export function parseFileUrls(value) {
	if (value === null || value === undefined) return [];
	if (Array.isArray(value)) return value.filter((v) => typeof v === 'string' && v.trim());
	if (typeof value === 'object' && value?.files && Array.isArray(value.files)) {
		return value.files.map((f) => f?.url).filter(Boolean);
	}
	if (typeof value !== 'string' || !value.trim()) return [];
	try {
		const parsed = JSON.parse(value);
		if (Array.isArray(parsed)) return parsed.filter((v) => typeof v === 'string' && v.trim());
	} catch (e) {
		// not JSON
	}
	// Single URL
	return [value.trim()];
}
